module.exports = __webpack_public_path__ + "static/img/second.4f8f9ec6.png";